import React, {Component} from 'react';
import {scaleQuantile} from 'd3-scale';

import DeckGL, {GeoJsonLayer, ArcLayer} from 'deck.gl';

export const inFlowColors = [
  [127, 255, 212],
  [124, 252, 0],
  [127, 255, 212],
  [0, 206, 209],
  [255, 215, 0],
  [ 124, 252, 0],
  [240, 128, 128],
  [255, 182, 193],
  [255, 0, 255],
  [72, 209, 204],
  [255, 255, 0]
];

export const outFlowColors = [
  [166, 3, 3]
];

export default class DeckGLOverlay extends Component {

  static get defaultViewport() {
    return {
      longitude: -30,
      latitude: 35.7,
      zoom: 2,
      maxZoom: 15,
      pitch: 30,
      bearing: 30
    };
  }

  constructor(props) {
    super(props);
    this.state = {
      arcs: this._getArcs(props)
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data !== this.props.data ||
        nextProps.selectedFeature !== this.props.selectedFeature
        || nextProps.selectedImports !== this.props.selectedImports
        || nextProps.selectedExports !== this.props.selectedExports
        || nextProps.passedSuppliers !== this.props.passedSuppliers
        ||nextProps.supplierChanged !== this.props.supplierChanged) {
      this.setState({
        arcs: this._getArcs(nextProps)
      });
    }
  }

  _getArcs({data, selectedFeature, selectedImports, selectedExports,passedSuppliers}) {
    if (!data || !selectedFeature) {
      return null;
    }

    const {flows, centroid} = selectedFeature.properties;
    const toId=null,featureId=null,arcs = [];
    var supplierId = null;
    for(toId in flows){
      const f = data[toId];
      for(var i in selectedFeature.properties.supplier){
        	for(var j=0;j<selectedFeature.properties.supplier[i].length;j++){
      	  if(selectedFeature.properties.supplier[i][j].to == toId){
              supplierId = i;
            }
        	}
      }
      if(selectedImports && selectedExports){
        if(passedSuppliers[supplierId]){
          arcs.push( {
            source: centroid,
            target: f.properties.centroid,
            value: flows[toId],
            sourceName:selectedFeature.properties.name,
            targetName:f.properties.name,
            type:'arc',
            toId:toId,
            supplier:supplierId
          })
        }
      }
      else if (selectedImports) {
        if(flows[toId] < 0){
          if(passedSuppliers[supplierId]){
            arcs.push( {
              source: centroid,
              target: f.properties.centroid,
              value: flows[toId],
              sourceName:selectedFeature.properties.name,
              targetName:f.properties.name,
              type:'arc',
              toId:toId,
              supplier:supplierId
            })
          }
        }
      }
      else {
        if(flows[toId] > 0){
          if(passedSuppliers[supplierId]){
            arcs.push( {
              source: centroid,
              target: f.properties.centroid,
              value: flows[toId],
              sourceName:selectedFeature.properties.name,
              targetName:f.properties.name,
              type:'arc',
              toId:toId,
              supplier:supplierId
            })
          }
        }
      }
    }

    const scale = scaleQuantile()
      .domain(arcs.map(a => Math.abs(a.value)))
      .range(inFlowColors.map((c, i) => i));

    const scaleWidth = scaleQuantile()
      .domain([0,3000])
      .range([0.1,5]);

    arcs.forEach(a => {
      a.gain = Math.sign(a.value);
      a.quantile = scale(Math.abs(a.value));
      a.width = scaleWidth(Math.abs(a.value))
    });

    return arcs;
  }

  _initialize(gl) {
    gl.enable(gl.DEPTH_TEST);
    gl.depthFunc(gl.LEQUAL);
  }

  render() {
    const {viewport, strokeWidth, data} = this.props;
    const {arcs} = this.state;

    if (!arcs) {
      return null;
    }

    const layers = [
      new GeoJsonLayer({
        id: 'geojson',
        data,
        stroked: true,
        filled: true,
        getFillColor: () => [0, 0, 0, 0],
        pickable: true,
        // onHover: this.props.onHover,
        // onClick: this.props.onClick,
        pickable: Boolean(this.props.onHover || this.props.onClick)
      }),
      new ArcLayer({
        id: 'arc',
        data: arcs,
        getSourcePosition: d => d.source,
        getTargetPosition: d => d.target,
        getSourceColor: d => (inFlowColors)[d.supplier],//(d.gain > 0 ? inFlowColors : outFlowColors)[d.quantile],
        getTargetColor: d => (inFlowColors)[d.supplier],//(d.gain > 0 ? outFlowColors : inFlowColors)[d.quantile],
        pickable: Boolean(this.props.onHover || this.props.onClick),
        onHover: this.props.onHover,
        onClick: this.props.onClick,
        strokeWidth
      })
    ];

    return (
      <DeckGL {...viewport} layers={ layers } onWebGLInitialized={this._initialize}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./deckgl-overlay.js